import { MissionInfo, ProfileType } from "../__generated__/graphql";
import React, { useContext } from "react";
import ListItem from "../ui_atoms/ListItem";
import { formatActivityTypeTitle, formatWorkingTimeClassicSpec } from "../utils";
import { ProfileSwitcherManagerContext } from "../contexts/ProfileSwitcherManager";
import { useI18n } from "../hooks/i18n-hooks";

type MissionInfoItemProps = {
    missionInfo: MissionInfo;
};

const MissionInfoItem: React.FC<MissionInfoItemProps> = ({ missionInfo }) => {
    const { profileType } = useContext(ProfileSwitcherManagerContext);
    const i18n = useI18n();
    return (
        <>
            {profileType === ProfileType.Client && (
                <ListItem
                    avatarPath={missionInfo?.workerInfo?.avatarUrl}
                    description={missionInfo?.workerInfo?.name}
                />
            )}
            {profileType === ProfileType.Worker && (
                <ListItem
                    avatarPath={missionInfo?.clientInfo?.logoUrl}
                    description={missionInfo?.clientInfo?.name}
                />
            )}
            <ListItem
                icon="tag"
                description={
                    missionInfo?.name ||
                    (missionInfo?.activityType?.title
                        ? formatActivityTypeTitle(
                              missionInfo?.activityType?.title,
                              missionInfo?.workerInfo?.gender,
                          )
                        : "")
                }
            />
            {missionInfo.workingTimeClassicSpec && (
                <ListItem
                    icon="clock"
                    description={formatWorkingTimeClassicSpec(
                        missionInfo.workingTimeClassicSpec,
                        i18n,
                    )}
                />
            )}
        </>
    );
};

export default MissionInfoItem;
